module.exports = __webpack_public_path__ + "static/media/SVK.9be24acd.jpg";